document.addEventListener("DOMContentLoaded", function () {
  const isMobile = window.innerWidth <= 768;

  if (typeof Swiper !== "undefined" && Swiper.hasOwnProperty("Mousewheel")) {
    Swiper.use([Swiper.Mousewheel]);
  }

  new Swiper(".custom-pdp-swiper__main", {
    direction: isMobile ? "horizontal" : "vertical",
    slidesPerView: 1,
    speed: 700,
    freeMode: true,
    spaceBetween: 10,
    mousewheel: isMobile
      ? false
      : {
          invert: false,
          sensitivity: 1,
          releaseOnEdges: true,
        },
    pagination: {
      el: ".custom-pdp-swiper .swiper-pagination",
      clickable: true,
    },
  });
});